<template>
  <aside
    class="mobile-nav"
    :class="{ 'mobile-nav--open': $store.state.isMobileMenuOpen }"
  >
    <div class="content">
      <header class="header">
        <LogoLink />

        <ButtonClose @click.native="$store.commit('toggleMobileMenu')" />
      </header>

      <MainNav @click="id => $emit('click', id)" />
    </div>

    <footer class="footer">
      <button class="button" @click="$store.commit('togglePopup', 'contact')">
        <img src="/images/contact.svg" alt="Kontakt" class="img" />
      </button>

      <LinksMedia class="links" />
    </footer>
  </aside>
</template>

<script>
import MainNav from '@/components/modules/MainNav'
import LinksMedia from '@/components/modules/LinksMedia'
import ButtonClose from '@/components/common/ButtonClose'

export default {
  components: {
    MainNav,
    LinksMedia,
    ButtonClose
  },
  methods: {
    handleClick(id) {
      this.$emit('click', id)
      this.$store.commit('toggleMobileMenu')
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: $vh;

  overflow-x: hidden;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: $background-color;

  padding: 25px 45px;

  @include media-down(md) {
    padding: 16px 20px;
  }

  transform: translate3d(100%, 0, 0);
  opacity: 0;
  transition: transform 0.25s ease-in-out, opacity 1s 0.25s;

  &--open {
    overflow-y: auto;
    opacity: 1;
    transform: translate3d(0, 0, 0);
    transition: transform 0.25s ease-in-out;
  }
}

.header {
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 70px;

  @include media-down(md) {
    margin-bottom: 30px;
  }
}

.footer {
  display: flex;
  padding: 37px 0;

  @include media-down(md) {
    padding: 20px 0;
  }
}

/deep/ .links {
  & .link {
    font-size: 23px;

    @include media-down(md) {
      font-size: 11px;
    }
  }
}

.img,
.links /deep/ .img {
  width: 58px;
  margin-right: 20px;

  @include media-down(md) {
    min-width: 29px;
    width: 29px;
  }
}

.button {
  @include reset-button;
}
</style>
